import React, { useEffect, useState } from 'react';
import { achievementsApi } from '../api';
import './AchievementBadges.css';
import { Achievement } from '../types/achievements';

interface AchievementBadgesProps {
  unlockedAchievements: Achievement[] | string[];
}

const AchievementBadges: React.FC<AchievementBadgesProps> = ({
  unlockedAchievements
}) => {
  const [allAchievements, setAllAchievements] = useState<Achievement[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAchievements = async () => {
      try {
        const response = await achievementsApi.getAllAchievements();
        if (response.data.status === 'success') {
          setAllAchievements(response.data.achievements);
        } else {
          setError('Failed to load achievements');
        }
      } catch (err) {
        setError('Failed to load achievements');
      } finally {
        setLoading(false);
      }
    };

    fetchAchievements();
  }, []);

  if (loading) return <div className="achievements-loading">Loading achievements...</div>;
  if (error) return <div className="achievements-error">{error}</div>;

  const isStringArray = (arr: any[]): arr is string[] => 
    arr.length === 0 || typeof arr[0] === 'string';

  return (
    <div className="achievements-container">
      <div className="achievements-scroll">
        {allAchievements.map((achievement) => {
          const isUnlocked = isStringArray(unlockedAchievements)
            ? unlockedAchievements.includes(achievement.id)
            : unlockedAchievements.some(a => a.id === achievement.id);
          
          return (
            <div 
              key={achievement.id}
              className={`achievement-card ${isUnlocked ? 'unlocked' : 'locked'}`}
              title={`${achievement.name}: ${achievement.description}`}
            >
              <div className="achievement-icon">
                {isUnlocked ? (
                  <img 
                    src={`/badges/${achievement.id}.png`} 
                    alt={`${achievement.name} badge`} 
                    className="achievement-icon-img"
                  />
                ) : '🔒'}
              </div>
              <div className="achievement-info">
                <div className="achievement-name">{achievement.name}</div>
                <div className="achievement-description">{achievement.description}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AchievementBadges; 